const type = {
    TYPE_MODEL_CODE_LABEL: 1,
    TYPE_INSTRUMENT_CODE_LABEL: 2,
    TYPE_COMPONENT_CODE_LABEL: 3,
    TYPE_COMPOUND_CODE_LABEL: 4,
    TYPE_RAW_MATERIAL_CODE_LABEL: 5,
    TYPE_MATERIAL_CODE_LABEL: 6,
    TYPE_MACHINE_CODE_LABEL: 7,
    TYPE_EMPLOYEE_CODE_LABEL: 8,
    TYPE_PRODUCT_SEARCH_MEASURE_RANGE_DEFAULT: 9,
    TYPE_ENTERPRISE_CODE_LABEL: 10,
    TYPE_ENVIRONMENT_CODE_LABEL: 11,
    TYPE_CHECKLIST_ITEM_CODE_LABEL: 12,
    TYPE_PATHOLOGY_CODE_LABEL: 13,
    TYPE_SPOT_FOLDER_CODE_LABEL: 14,
    TYPE_INSPECTOR_CODE_LABEL: 15,
}

const render = {
    RENDER_TAG_COD_LABEL: "settingCodeLabel",
}

const mode = {
    MODE_CODE_LABEL_AUTOMATIC_DEFAULT: "automatic-default",
    MODE_CODE_LABEL_MANUAL: "manual",
}

export default {
    type,
    render,
    mode
}